import { packValidateResults, required, url } from 'helpers/validators';
import { AmlDomainEditProps } from 'services/API/Aml_Domain/interface';

export const validate = (data: AmlDomainEditProps) =>
  packValidateResults([required(data, ['domain', 'protocol']), url(data, ['domain'])]);
